"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var utils_1 = require("../utils");
var Collapsable = /** @class */ (function (_super) {
    tslib_1.__extends(Collapsable, _super);
    function Collapsable(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setRef = function (el) {
            _this.$el = el;
        };
        _this.$el = null;
        _this.timer = null;
        _this.height = 0;
        _this.willUnmount = false;
        return _this;
    }
    Collapsable.prototype.componentDidMount = function () {
        var _this = this;
        var animationDuration = this.props.animationDuration;
        this.handleToggle(this.props, true);
        utils_1.raf(function () {
            if (_this.willUnmount) {
                return;
            }
            _this.$el.style.transition = "height " + animationDuration + "ms, opacity " + animationDuration + "ms";
        });
    };
    Collapsable.prototype.componentWillUnmount = function () {
        this.willUnmount = true;
    };
    Collapsable.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (this.props.collapsed !== nextProps.collapsed) {
            this.handleToggle(nextProps);
        }
    };
    Collapsable.prototype.handleToggle = function (nextProps, firstRender) {
        if (nextProps.collapsed) {
            this.height = this.$el.offsetHeight;
            this.slideUp(firstRender);
        }
        else if (!firstRender) {
            this.slideDown();
        }
    };
    Collapsable.prototype.slideUpEnd = function () {
        this.$el.style.overflow = "hidden";
        this.$el.style.height = "0";
        this.$el.style.opacity = "0";
    };
    Collapsable.prototype.slideUp = function (skipAnimation) {
        var _this = this;
        var _a = this.props, collapseEnd = _a.collapseEnd, animationDuration = _a.animationDuration;
        clearTimeout(this.timer);
        if (skipAnimation) {
            this.slideUpEnd();
            collapseEnd();
            return;
        }
        utils_1.raf(function () {
            _this.$el.style.overflow = "hidden";
            _this.$el.style.height = _this.height + "px";
            _this.$el.style.opacity = "1";
            utils_1.raf(function () {
                _this.slideUpEnd();
            });
        });
        this.timer = setTimeout(function () {
            collapseEnd();
        }, animationDuration);
    };
    Collapsable.prototype.slideDown = function () {
        var _this = this;
        var _a = this.props, animationDuration = _a.animationDuration, collapseEnd = _a.collapseEnd;
        clearTimeout(this.timer);
        utils_1.raf(function () {
            _this.$el.style.overflow = "hidden";
            _this.$el.style.height = _this.height + "px";
            _this.$el.style.opacity = "1";
        });
        this.timer = setTimeout(function () {
            utils_1.raf(function () {
                _this.$el.style.overflow = "";
                _this.$el.style.height = "";
                _this.$el.style.opacity = "";
                collapseEnd();
            });
        }, animationDuration);
    };
    Collapsable.prototype.render = function () {
        var _a = this.props, children = _a.children, style = _a.style, animationDuration = _a.animationDuration, collapsed = _a.collapsed, collapseEnd = _a.collapseEnd, others = tslib_1.__rest(_a, ["children", "style", "animationDuration", "collapsed", "collapseEnd"]);
        return (React.createElement("div", tslib_1.__assign({ ref: this.setRef }, others, { style: style }), children));
    };
    Collapsable.defaultProps = {
        style: {},
        animationDuration: 300,
        collapseEnd: utils_1.noop
    };
    return Collapsable;
}(React.Component));
exports.default = Collapsable;
